import React, { useRef, useEffect } from 'react';
import { X, Phone } from 'lucide-react';

export function ContactModal({ open, onClose, order }) {
  if (!open) return null;

  const handleCall = () => {
    window.open(`tel:+51${order.telefono}`, '_self');
  };

  const handleWhatsApp = () => {
    const message = 'Hola, estoy en camino para recoger tu pedido.';
    window.open(`https://wa.me/51${order.telefono}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 2000 }}>
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="bg-white rounded-2xl w-full max-w-md relative">
        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Contacto</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6">
          <div>
            <p className="text-sm font-semibold text-gray-500 mb-3">Cliente: {order?.customer_name}</p>
            <div className="flex gap-3">
              <button
                onClick={handleWhatsApp}
                className="flex-1 bg-brand-green text-white py-3 rounded-lg font-semibold hover:bg-brand-green/90 flex items-center justify-center gap-2"
              >
                <Phone className="w-5 h-5" />
                WhatsApp
              </button>
              <button
                onClick={handleCall}
                className="flex-1 bg-brand-gold text-white py-3 rounded-lg font-semibold hover:bg-brand-gold/90 flex items-center justify-center gap-2"
              >
                <Phone className="w-5 h-5" />
                Llamar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
